export default __webpack_public_path__ + "static/ak-cached/24h/media/premium-channel-bg.0ace163b.png";